export default __webpack_public_path__ + "static/media/blog-42-1.4d1cdd20.jpg";